import { render, staticRenderFns } from "./yudao.vue?vue&type=template&id=508dc09e&scoped=true&"
import script from "./yudao.vue?vue&type=script&lang=js&"
export * from "./yudao.vue?vue&type=script&lang=js&"
import style0 from "./yudao.vue?vue&type=style&index=0&id=508dc09e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508dc09e",
  null
  
)

export default component.exports